"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bidinfo = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/bidinfo");
const Actions = require("../../actions/bidinfo");
const errorHandling_1 = require("../../utils/errorHandling");
const bid_1 = require("@caddigital/sok-types/lib/bid");
function bidinfo(action$, _store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.BID_STATUS_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: action.payload,
        url: `${baseUrl}api/bid/bid-info`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        const validation = t
            .interface({
            bidinfo: bid_1.iBidInfo
        })
            .decode(xhr.response);
        const act = validation.fold((e) => [Actions.bidinfoFailure((0, errorHandling_1.parseValidationError)(e))], (res) => {
            const acts = [Actions.bidinfoSuccess(res.bidinfo)];
            return acts;
        });
        return (0, rxjs_1.of)(...act);
    }), (0, operators_1.catchError)((error) => {
        return (0, rxjs_1.of)(Actions.bidinfoFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)));
    }))));
}
exports.bidinfo = bidinfo;
//# sourceMappingURL=index.js.map